const DEFAULT_CAPABILITIES = {
    isAuthorized: false,
    context: {
        companyId: null,
        planIds: [],
        modules: [],
        features: [],
        accessFeatures: [],
        limits: {},
        subscriptions: [],
    },
    subscriptions: [],
    usage: {},
    alerts: [],
    upgradeOptions: {},
};

export const normalizeCapabilities = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return { ...DEFAULT_CAPABILITIES };
    }

    const normalized = {
        isAuthorized: payload.isAuthorized ?? false,
        context: normalizeContext(payload.context || {}),
        subscriptions: payload.subscriptions ?? [],
        usage: payload.usage ?? {},
        alerts: payload.alerts ?? [],
        upgradeOptions: payload.upgradeOptions ?? {},
    };

    return normalized;
};

const normalizeContext = (context) => {
    const normalized = {
        companyId: context.companyId ?? null,
        planIds: ensureArray(context.planIds ?? context.plan_ids),
        modules: ensureArray(context.modules ?? context.module),
        features: normalizeFeatures(context.features ?? context.featuresList),
        accessFeatures: normalizeFeatures(context.accessFeatures ?? context.access_features),
        limits: context.limits ?? context.limit ?? {},
        subscriptions: ensureArray(context.subscriptions ?? context.subscription),
    };

    return normalized;
};

const normalizeFeatures = (features) => {
    if (!features) {
        return [];
    }

    if (Array.isArray(features)) {
        return features.filter(f => typeof f === 'string');
    }

    if (typeof features === 'object') {
        return Object.keys(features).filter(k => typeof k === 'string');
    }

    return [];
};

const ensureArray = (value) => {
    if (!value) {
        return [];
    }
    if (Array.isArray(value)) {
        return value;
    }
    if (typeof value === 'object') {
        return Object.keys(value);
    }
    return [];
};

export const mergeWithDefaults = (capabilities) => {
    return {
        ...DEFAULT_CAPABILITIES,
        ...capabilities,
        context: {
            ...DEFAULT_CAPABILITIES.context,
            ...(capabilities?.context || {}),
        },
    };
};

export const getDefaultCapabilities = () => {
    return JSON.parse(JSON.stringify(DEFAULT_CAPABILITIES));
};
